import axios from 'axios'

export default {
  search (request) {
    return axios.get('/api/admin/log/search', {params: request});
  },
  getCategories () {
    return axios.get('/api/admin/log/getCategories', {});
  },
  getSeverities () {
    return axios.get('/api/admin/log/getSeverities', {});
  },
  getEntityTypes () {
    return axios.get('/api/admin/log/getEntityTypes', {});
  },
  getDictionaries () {
    return axios.get('/api/admin/log/getDictionaries', {});
  }
}